import ChoiceResponseMapperBase from './ChoiceResponseMapperBase';

export default class MultipleChoiceImageResponseMapper extends ChoiceResponseMapperBase {
  _unMapFailedResponse(userAnswer: any, answers: any) {
    return userAnswer.map((answer: any) =>  answers[answer].id);
  }
}
